module.exports = __webpack_public_path__ + "static/media/bar-top.c2f45c13.svg";